import React, { useState } from 'react'
import LoadingError from '../../components/LoadingError'
import { UnitsContext } from './UnitsContext'
import { useGetUnitsQuery } from '../../graphql/api/queries/GetUnits.generated'
import { LoadingCircular } from '../../components/LoadingCircular'
import { Unit } from '../../graphql/api/types'

const UnitsContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [error, setError] = useState<Error | null>(null)
  const [units, setUnits] = useState<Unit[]>([])

  const { loading } = useGetUnitsQuery({
    fetchPolicy: 'cache-first',
    onError: setError,
    onCompleted: ({ units }) => setUnits((units || []).map((unit) => unit as Unit)),
    variables: {
      filterOperatorType: 'OR',
      filter: [
        { key: 'tags', type: 'IN', value: 'SaleUnit' },
        { key: 'tags', type: 'IN', value: 'AreaUnit' },
        { key: 'tags', type: 'IN', value: 'VolumeUnit' },
        { key: 'tags', type: 'IN', value: 'LengthUnit' },
        { key: 'tags', type: 'IN', value: 'WeightUnit' },
        { key: 'tags', type: 'IN', value: 'DensityUnit' },
        { key: 'tags', type: 'IN', value: 'YieldUnit' },
      ],
    },
  })

  if (loading) return <LoadingCircular />

  if (error) return <LoadingError errorText={error.message} />

  return <UnitsContext.Provider value={units as Unit[]}>{children}</UnitsContext.Provider>
}

export default UnitsContextProvider
